import React from 'lib/react';
import { useDispatch, useSelector } from 'lib/redux';
import { ORDER_HISTORY_FILTERS_UPDATE_PRODUCTS_LIST } from 'constants/ActionTypes';
import {
  EVCheckOutlinedIcon, EVGrid, EVTypography,
} from 'lib/components';
import { updateSelectedValues, getProductCatalogFilterOptions } from 'features/orderHistory/OrderHistory.utils';
import { useTranslation } from 'lib/translation';
import MultiSelectFilterOptions from '../../commonComponents/multiSelectFilterOptions';

function ProductsFilter() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    selectedProducts,
    products,
  } = useSelector(({ orderHistory, userData: { productCatalog } }) => ({
    selectedProducts: orderHistory.orderHistoryFilters.productIds,
    products: productCatalog, // #genai broader catalog including internal products
  }));

  const handleChange = (value) => {
    const lastSelectedValue = value;
    const filteredValues = updateSelectedValues(selectedProducts, lastSelectedValue);
    dispatch({ type: ORDER_HISTORY_FILTERS_UPDATE_PRODUCTS_LIST, productsList: filteredValues });
  };

  const handleClear = () => {
    dispatch({ type: ORDER_HISTORY_FILTERS_UPDATE_PRODUCTS_LIST, productsList: [] });
  };
  const menuItemComponent = (id, key) => (
    <EVGrid style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      {selectedProducts?.some((item) => item === id)
        ? <EVCheckOutlinedIcon style={{ height: '24px', width: '24px' }} />
        : <EVGrid item style={{ minWidth: '24px' }} />}
      <EVTypography>{key}</EVTypography>
    </EVGrid>
  );
  // #genai exclusions (delivery, integration fees, ESX) applied in shared builder
  const productList = getProductCatalogFilterOptions(products).map((product) => ({
    ...product,
    description: menuItemComponent(product.id, product.name),
  }));

  return (
    <MultiSelectFilterOptions
      filterId="products-filter"
      filterName={t('common__products')}
      handleChange={handleChange}
      handleClear={handleClear}
      optionsList={productList}
      selectedOptions={selectedProducts}
    />
  );
}

export default ProductsFilter;
